/**
 * Generates CSS for applying a disabled effect to an element.
 */ function disabled() {
    return (theme)=>({
            cursor: 'default',
            opacity: theme.opacities.weaker
        });
}

export { disabled };
//# sourceMappingURL=disabled.js.map
